import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';

import { ReportsService } from 'src/app/core/services/reports.service';
import { StudentsService } from 'src/app/core/services/students.service';
import { SessionStorageService } from 'src/app/core/services/session-storage.service';

import { ManagementUser } from 'src/app/core/models/management-user.model';
import { Student } from 'src/app/core/models/student.model';
import { SchoolAdminTeacherFilterService } from 'src/app/shared/components/school-admin-teacher-filter/school-admin-teacher-filter.service';

interface CoTeacherResolveData {
  students: Student[];
  teachers: ManagementUser[];
}

@Injectable({
    providedIn: 'root'
})
export class CoTeacherResolver {
    constructor(
        private studentService: StudentsService,
        private sessionService: SessionStorageService,
        private reportsService: ReportsService,
        private teacherFilterService: SchoolAdminTeacherFilterService,
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CoTeacherResolveData> {
        const managementUser = this.sessionService.userData() ;
        const studentListScope = managementUser?.isSchoolAdmin() ? 'school' : 'mine';
        const fetchTeacherData = managementUser && (managementUser.isTeacherUser() || managementUser.isSchoolAdmin());

        return this.teacherFilterService.initSchoolAdminTeacherFilter({allowAllOption: false})
          .pipe(
            switchMap(
              () => forkJoin([
                this.studentService.getStudents(studentListScope),
                (fetchTeacherData) ? this.reportsService.getAllActiveTeachers(managementUser, managementUser?.schoolID || -1) : of([]),
              ])
            )
          )
          .pipe(
            map((results) => {
              let students = results[0];
              let teachers = results[1];

              students.forEach((student) => {
                student.fullName = student.firstName + ' ' + student.lastName;
              });

              return {
                students,
                teachers,
              };
            })
        );
    }
}
